import Tooltip from './Tooltip';
export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-tooltip/es/index.js
// module id = null
// module chunks = 